<div class="flex-details-container">
  <div class="card card-body p-3 mb-3">
    <div class="d-flex align-items-center gap-2 mb-2">
        <div class="flex-details-header-container">
            <timetracking-status-indicator 
                [statusId]="0"
                [a48ContextCode]="null"
                [timeTrackingType]="TimeTrackingType.FLEX"
                ngbTooltip="Flex Hours Status"
                placement="bottom"></timetracking-status-indicator>
            <h4 class="card-title mb-0">
                {{ userName }} - Flex Hours Configuration
            </h4>
        </div>

    </div>
    
    <div class="row">
      <div class="col-md-6">
        <small class="text-muted">
          <strong>Compliance Item:</strong> {{ complianceItemTitle }}
        </small>
      </div>
    </div>
  </div>

  <div class="flex-form-wrapper">
    <div class="mb-3">
      <h5 class="mb-2">
        <i class="fas fa-cog me-2"></i>
        Recorded Hours
      </h5>
    </div>
    
    <div class="form-content">
      <div class="form-group row align-items-center">
        <label for="flexHoursInput" class="col-sm-4 col-form-label">Flex Hours:</label>
        <div class="col-sm-8">
          <input
            id="flexHoursInput"
            type="number"
            min="0"
            class="form-control"
            [value]="flexHours"
            [disabled]="isReadOnly || busy"
            (input)="onHoursInput($event)"
          />
        </div>
      </div>
    </div>

    <div class="flex-details-actions mt-3">
      <div class="d-flex justify-content-end">
        <button 
          type="button" 
          class="btn btn-secondary"
          [class.flex-btn-busy]="busy"
          [disabled]="!canSave() || busy"
          [attr.aria-disabled]="busy ? 'true' : null"
          (click)="onSave()">
          <i *ngIf="busy" class="fas fa-spinner fa-spin me-2" aria-label="Loading"></i>
          <span *ngIf="!busy">Save</span>
        </button>
        <div aria-live="polite" class="visually-hidden">
          <span *ngIf="busy">Saving, please wait...</span>
        </div>
      </div>
    </div>
  </div>
</div>